import { ShipmentDates } from '@diamond/shared/types';
import { useQuery } from '@tanstack/react-query';

import {
  getShipmentDates,
  ShipmentDateException,
} from '../queries/shipment-dates';
import { useAuthStore } from '../stores';

export const useGetShipmentDates = (
  warehouse: string,
  handleRetry: (failureCount: number, error: ShipmentDateException) => boolean
) => {
  const session = useAuthStore();
  const runQuery = typeof warehouse === 'string';

  return useQuery<ShipmentDates, ShipmentDateException>({
    queryKey: ['ShipmentDates', warehouse],
    queryFn: () => getShipmentDates(session.access_token, warehouse),
    enabled: runQuery,
    retry: handleRetry,
  });
};
